import React from "react";
import { Search, XCircle } from "@semo/icons";
import { Badge, Input } from "@semo/shared-ui";

interface ProductSearchBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onSearchClear?: () => void;
  selectedCategoryName?: string | null;
  onCategoryClear?: () => void;
  isFetching?: boolean;
  placeholder?: string;
  className?: string;
}

export const ProductSearchBar: React.FC<ProductSearchBarProps> = ({
  searchTerm,
  onSearchChange,
  onSearchClear,
  selectedCategoryName,
  onCategoryClear,
  isFetching,
  placeholder = "상품명, 브랜드, 코드 등으로 검색...",
  className = "h-12",
}) => {
  return (
    <div className={`relative w-full group ${className}`}>
      <div
        className={`
        relative flex items-center gap-2 px-3 h-full bg-muted/20 border border-muted-foreground/20 
        focus-within:bg-background focus-within:border-primary transition-all shadow-sm rounded-xl
        ${isFetching ? "ring-1 ring-primary/20" : ""}
      `}
      >
        <Search className="h-4 w-4 text-muted-foreground shrink-0" />
        {selectedCategoryName && (
          <Badge className="gap-1 px-2 py-1 h-[70%] bg-primary/15 text-primary-text hover:bg-primary/20 border-transparent transition-colors shrink-0">
            <span className="max-w-[120px] truncate">
              {selectedCategoryName}
            </span>
            {onCategoryClear && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onCategoryClear();
                }}
                className="hover:bg-primary/20 rounded-full p-0.5"
              >
                <XCircle className="h-3 w-3" />
              </button>
            )}
          </Badge>
        )}
        <Input
          placeholder={
            selectedCategoryName
              ? `'${selectedCategoryName}' 내에서 검색...`
              : placeholder
          }
          className="border-0 bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0 h-full text-sm p-0"
          value={searchTerm}
          onChange={(e) => {
            onSearchChange(e.target.value);
          }}
        />
        {searchTerm && onSearchClear && (
          <button
            onClick={onSearchClear}
            className="text-muted-foreground hover:text-foreground shrink-0"
          >
            <XCircle className="h-4 w-4" />
          </button>
        )}
        {isFetching && (
          <div className="flex items-center gap-1 shrink-0 ml-2">
            <div className="w-1 h-1 bg-primary rounded-full animate-bounce [animation-delay:-0.3s]"></div>
            <div className="w-1 h-1 bg-primary rounded-full animate-bounce [animation-delay:-0.15s]"></div>
            <div className="w-1 h-1 bg-primary rounded-full animate-bounce"></div>
          </div>
        )}
      </div>
    </div>
  );
};
